var map = {
	"./en.json": [
		20790
	],
	"./es.json": [
		18563,
		563
	],
	"./hi.json": [
		39493,
		493
	],
	"./ru.json": [
		69672,
		672
	],
	"./zh.json": [
		66538,
		538
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7535;
module.exports = webpackAsyncContext;